import { render, staticRenderFns } from "./ShippingCost.vue?vue&type=template&id=23a28521&"
import script from "./ShippingCost.vue?vue&type=script&lang=js&"
export * from "./ShippingCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports